import React, { Component, useState } from 'react';
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import { Trans } from 'react-i18next';
import { useLazyQuery, useMutation } from '@apollo/client';

import { GET_BOOKING_BY_SOURCE_ID } from '../../GraphQL/Queries/bookings';
import { UPDATE_BOOKING } from '../../GraphQL/Mutations/bookings';
import { openPullout, closePullout, setList } from "../../Actions/endUserActions";

import VehicleCell from "../Pages/Stakeholder/Vehicle/VehicleCell";
import ProfileCell from "../Pages/Stakeholder/User/ProfileCell";

import { constants } from '../../Helpers/Constants';
import { receiveTime, reverseReceiveTime } from '../../Helpers/ReceiveTimeInArray';
import EUEditBookingPullout from './EUEditBookingPullout';

const CancelBookingButton = ({ legacyApiCancelBooking, booking, closePullout, fetchBookings }) => {
    const [loadingCancel, setLoadingCancel] = useState(false);

    // const [updateBookingMutation, { data, loading, error }] = useMutation(UPDATE_BOOKING);
    const [getBookingQuery, { loading: loadingBooking }] = useLazyQuery(GET_BOOKING_BY_SOURCE_ID, {
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
    });

    // [not in use due to queue data sync implementation]
    const cancelBookingGraphQL = () => {
        // TODO: remove this query when we migrate the booking list to graphql (we'll have the correct booking id)
        getBookingQuery({ variables: { sourceBookingId: +booking.BOOK_ID } })
            .then((bookingResponse) => {
                const bookingId = bookingResponse?.data.getBookingBySourceBookingId.id

                const cancelBookingInput = {
                    id: +bookingId,
                    status: 'cancelled',
                }

                // updateBookingMutation({ variables: { input: cancelBookingInput } }).then((response) => {
                //     // setLoadingCancel(false);
                //     // closePullout();
                //     // fetchBookings();
                //     // showStatusMsg('Booking cancelled successfully.', 'success');
                // }).catch((error) => {
                //     setLoadingCancel(false);
                //     console.error('[updateBookingMutation] error: ', error);
                // });
            }).catch((error) => {
                setLoadingCancel(false);
                console.error('[getBooking] error: ', error);
            });
    }

    const cancelBooking = () => {
        // setLoadingCancel(true);
        legacyApiCancelBooking(cancelBookingGraphQL, setLoadingCancel);
    };

    return (
        <button className="button alert ml-16" onClick={cancelBooking} disabled={loadingCancel} >
            <Trans>Cancel Booking</Trans>
        </button>
    )
}

//A React component will allow us to quickly iterate and change our code. It provides 
class EUBookingPullout extends Component {
    constructor(props) {
        super(props);

        // this.cancelBooking = debounce(this.cancelBooking.bind(this), 500);
        this.cancelBooking = this.cancelBooking.bind(this);
        this.editBooking = this.editBooking.bind(this);
        this.closePullout = this.closePullout.bind(this);
        this.submitEdit = this.submitEdit.bind(this);
        this.grabBookings = this.grabBookings.bind(this);

        this.selectStartDate = this.selectStartDate.bind(this);
        this.selectEndDate = this.selectEndDate.bind(this);
        this.updateForm = this.updateForm.bind(this);
        this.changeTime = this.changeTime.bind(this);
        this.updateFormDropdown = this.updateFormDropdown.bind(this);
        this.getUserLocaleTime = this.getUserLocaleTime.bind(this);

        this.state = {
            edit: false,
            pickup_timings: [],
            dropoff_timings: [],
            vehicle_form: {},
            tempLocaleTime: {}
        };
    }

    getUserLocaleTime (){
        const scheduledReleasedAt = moment(this.props?.endUser?.current_booking?.extendedProps?.booking?.scheduledReleasedAt).format('YYYY-MM-DDTHH:mm:ssZ') 
        const scheduledReturnedAt = moment(this.props?.endUser?.current_booking?.extendedProps?.booking?.scheduledReturnedAt).format('YYYY-MM-DDTHH:mm:ssZ')        
        return {
            scheduledReleasedAt,
            releaseTime: moment(scheduledReleasedAt).format("h:mm a"),
            releaseDate: moment(scheduledReleasedAt).format("MMM D, YYYY"),
            scheduledReturnedAt,
            returnTime: moment(scheduledReturnedAt).format("h:mm a"),
            returnDate: moment(scheduledReturnedAt).format("MMM D, YYYY"),
        }
    }

    selectStartDate(event) {
        var vehicle_form = this.state.vehicle_form
        vehicle_form["start_date"] = event.target.value

        this.setState({
            vehicle_form: vehicle_form,
            tempLocaleTime: {
                ...this.state.tempLocaleTime,
                releaseDate: undefined
            }
        })

        this.loadPickupTimes(event.target.value);
    }

    selectEndDate(event) {
        var vehicle_form = this.state.vehicle_form
        vehicle_form["end_date"] = event.target.value

        this.setState({
            vehicle_form: vehicle_form,
            tempLocaleTime: {
                ...this.state.tempLocaleTime,
                returnDate: undefined
            }
        })

        this.loadDropoffTimes(event.target.value);
    }

    loadPickupTimes(date) {
        var self = this;

        axios.post('/ajax/vehicle/' + this.props.endUser.current_booking.V_ID + "/options", {
            'date': date,
            'type': 'pickup',
            'booking_id': this.props.endUser.current_booking.BOOK_ID,
        })
            .then(function (response) {
                self.setState({
                    pickup_timings: response?.data
                })
            })
    }

    loadDropoffTimes(date) {
        var self = this;
        axios.post('/ajax/vehicle/' + this.props.endUser.current_booking.V_ID + "/options", {
            'date': date,
            'type': 'dropoff',
            'booking_id': this.props.endUser.current_booking.BOOK_ID,
        })
            .then(function (response) {
                self.setState({
                    dropoff_timings: response?.data
                })
            })
    }

    changeTime(option) {
        var vehicle_form = this.state.vehicle_form
        var timing = option.value
        var name = option.name
        var self = this;
        vehicle_form[name] = timing;
        let tempLocaleTime =  {...this.state.tempLocaleTime};
        if (name === "pick_up_time") {
            delete tempLocaleTime.releaseTime
        } else if (name === "drop_off_time") {
            delete tempLocaleTime.returnTime
        }

        self.setState({
            vehicle_form: vehicle_form,
            tempLocaleTime
        })
    }

    cancelBooking(cancelBookingGraphQL, setLoading) {
        var self = this;

        if (window.confirm("Are you sure you would like to cancel this booking?")) {
            axios.post('/ajax/booking/' + self.props.endUser.current_booking.BOOK_ID + '/delete')
                .then(function (response) {
                    // [not in use due to queue data sync implementation]
                    // cancelBookingGraphQL();
                    self.closePullout();
                    self.grabBookings();
                    showStatusMsg('Booking cancelled successfully.', 'success');
                })
                .catch(function (error) {
                    setLoading(false);
                    if (error.response?.status == 401) {
                        showStatusMsg(error.response?.data.error);
                    } else if (error.response?.status == 422) {
                        var error_message = "";

                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });

                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
        }
    }

    editBooking() {
        let vehicle_form = this.state.vehicle_form

        if (!this.state.edit) {
            vehicle_form['vehicle_id'] = this.props.endUser.current_booking.V_ID
            vehicle_form['start_date'] = this.props.endUser.current_booking.Start_Date
            vehicle_form['end_date'] = this.props.endUser.current_booking.End_Date
            vehicle_form['pick_up_time'] = receiveTime(moment(this.props.endUser.current_booking.Release_Time, "HH:mm:ss").format("h:mmA"))
            vehicle_form['drop_off_time'] = receiveTime(moment(this.props.endUser.current_booking.Return_Time, "HH:mm:ss").format("h:mmA"))
            vehicle_form['pick_up_location'] = this.props.endUser.current_booking.Release_Address
            vehicle_form['drop_off_location'] = this.props.endUser.current_booking.Return_Address
            vehicle_form['booking_type'] = this.props.endUser.current_booking.Book_Type
            vehicle_form['user'] = this.props.endUser.current_booking.Profile_ID
            vehicle_form['vehicle_usage'] = this.props.endUser.current_booking.Usage_Type
            vehicle_form['service_usage'] = this.props.endUser.current_booking.Vehicle_Usage
            vehicle_form['pick_up_person'] = this.props.userSession.user.full_name
            vehicle_form['notes'] = this.props.endUser.current_booking.Special_Requests

            this.loadPickupTimes(this.props.endUser.current_booking.Start_Date);
            this.loadDropoffTimes(this.props.endUser.current_booking.End_Date);
        }

        this.setState({
            edit: !this.state.edit,
            vehicle_form: vehicle_form,
            tempLocaleTime: this.getUserLocaleTime()
        })
    }

    updateForm(event) {
        var name = event.target.name;
        var value = event.target.value;

        var vehicle_form = this.state.vehicle_form;
        vehicle_form[name] = value;

        this.setState({
            vehicle_form: vehicle_form
        })
    }

    updateFormDropdown(event) {
        var name = event.name;
        var value = event.value;

        var vehicle_form = this.state.vehicle_form;

        vehicle_form[name] = value;

        this.setState({
            vehicle_form: vehicle_form
        })
    }

    grabBookings() {
        var tab_name = this.props.match.url.split("/")[2]
        var self = this;

        if (tab_name === "current") {
            axios.get('/ajax/mybookings/current')
                .then(function (response) {
                    self.props.dispatch(setList("SET_CURRENT_BOOKINGS_LIST", response?.data.bookings.current))
                })
                .catch(function (error) {
                    if (error.response?.status == 401) {
                        showStatusMsg(error.response?.data.error);
                    } else if (error.response?.status == 422) {
                        var error_message = "";

                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });

                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
        } else if (tab_name === "upcoming") {
            axios.get('/ajax/mybookings/upcomming')
                .then(function (response) {
                    self.props.dispatch(setList("SET_UPCOMING_BOOKINGS_LIST", response?.data.bookings.upcomming))
                })
                .catch(function (error) {
                    if (error.response?.status == 401) {
                        showStatusMsg(error.response?.data.error);
                    } else if (error.response?.status == 422) {
                        var error_message = "";

                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });

                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
        } else if (tab_name === "pending") {
            axios.get('/ajax/mybookings/pending')
                .then(function (response) {
                    self.props.dispatch(setList("SET_PENDING_BOOKINGS_LIST", response?.data.bookings.pending))
                })
                .catch(function (error) {
                    if (error.response?.status == 401) {
                        showStatusMsg(error.response?.data.error);
                    } else if (error.response?.status == 422) {
                        var error_message = "";

                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });

                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
        } else if (tab_name === "rejected") {
            axios.get('/ajax/mybookings/rejected')
                .then(function (response) {
                    self.setState({
                        rejected_bookings: response?.data.bookings.denied
                    })
                })
                .catch(function (error) {
                    if (error.response?.status == 401) {
                        showStatusMsg(error.response?.data.error);
                    } else if (error.response?.status == 422) {
                        var error_message = "";

                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });

                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
        } else if (tab_name === "past") {
            axios.get('/ajax/mybookings/past')
                .then(function (response) {
                    self.setState({
                        past_bookings: response?.data.bookings.past
                    })
                })
                .catch(function (error) {
                    if (error.response?.status == 401) {
                        showStatusMsg(error.response?.data.error);
                    } else if (error.response?.status == 422) {
                        var error_message = "";

                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });

                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
        } else if (tab_name === "cancelled") {
            axios.get('/ajax/mybookings/cancelled')
                .then(function (response) {
                    self.setState({
                        cancelled_bookings: response?.data.bookings.cancelled
                    })
                })
                .catch(function (error) {
                    if (error.response?.status == 401) {
                        showStatusMsg(error.response?.data.error);
                    } else if (error.response?.status == 422) {
                        var error_message = "";

                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });

                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
        }
    }

    submitEdit(updateBookingGraphQL, setLoading) {
        const editBookingSuccessActions = () => {
            const booking = this.props.endUser.current_booking;

            booking['Start_Date'] = this.state.vehicle_form['start_date']
            booking['End_Date'] = this.state.vehicle_form['end_date']
            booking['Release_Time'] = moment(reverseReceiveTime(this.state.vehicle_form['pick_up_time']), "h:mmA").format("HH:mm:ss")
            booking['Return_Time'] = moment(reverseReceiveTime(this.state.vehicle_form['drop_off_time']), "h:mmA").format("HH:mm:ss")
            booking['Usage_Type'] = this.state.vehicle_form['vehicle_usage']
            booking['Special_Requests'] = this.state.vehicle_form['notes']

            this.props.dispatch(openPullout(booking));

            showStatusMsg('Booking updated successfully', 'success');

            this.grabBookings();

            this.setState({
                edit: false,
                vehicle_form: {}
            })
        }

        axios.post('/ajax/booking/' + this.props.endUser.current_booking.BOOK_ID + "/update", this.state.vehicle_form)
            .then((response) => {
                // [not in use due to queue data sync implementation]
                // updateBookingGraphQL(this.state.vehicle_form, this.state.tempLocaleTime, editBookingSuccessActions)
                editBookingSuccessActions();
            })
            .catch(function (error) {
                setLoading(false);
                if (error.response?.status == 401) {
                    showStatusMsg(error.response?.data.error);
                } else if (error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    closePullout() {
        this.setState({
            edit: false
        })

        this.props.dispatch(closePullout());
    }

    render() {
        if (this.props.endUser.pullout) {
            if (this.state.edit) {
                return (
                    <EUEditBookingPullout
                        closePullout={this.closePullout}
                        submitEdit={this.submitEdit}
                        editBooking={this.editBooking}
                        changeTime={this.changeTime}
                        updateForm={this.updateForm}
                        updateFormDropdown={this.updateFormDropdown}
                        selectStartDate={this.selectStartDate}
                        selectEndDate={this.selectEndDate}
                        state={this.state}
                        {...this.props}
                    />
                )
            } else {
                return (
                    <div className="booking_pullout_user">
                        <div className="booking_header border-bottom">
                            <div className="card-header-title float-left no-margin"><Trans>Booking Details</Trans></div>
                            <button className="float-right" onClick={() => this.props.dispatch(closePullout())} type='button' style={{ cursor: "pointer" }}>
                                <span aria-hidden='true' style={{ fontSize: "2em", lineHeight: 1, display: "block" }}>&times;</span>
                            </button>
                            <div className="clearfix"></div>
                        </div>
                        <div className="booking_main">
                            <div className="booking_main_item">
                                <div className="booking_main_item_header booking_main_item_active">
                                    <span className="booking_main_item_header_text"><Trans>Vehicle</Trans></span>
                                </div>
                                <div className="booking_main_item_subheader booking_main_item_active">
                                    <div className="booking_main_item_subheader_vehicle">
                                        <VehicleCell history={this.props.history} match={this.props.match} location={this.props.location} vehicle={this.props.endUser.current_booking.vehicle} showImage noOverlay noTooltip />
                                    </div>
                                </div>
                            </div>
                            <div className="booking_main_item">
                                <div className="booking_main_item_header booking_main_item_active">
                                    <span className="booking_main_item_header_text mb-8"><Trans>Dates & Times</Trans></span>
                                </div>
                                <div className="booking_main_item_subheader booking_main_item_active">
                                    <div className="overlay_section_details_date_container">
                                        <div className="overlay_section_details_date_left">
                                            <div className="booking_main_date_text_active">
                                                {moment(this.props.endUser.current_booking.Start_Date).format("MMM DD, YYYY")}
                                            </div>
                                            <div className="booking_main_date_text_active">
                                                {moment(this.props.endUser.current_booking.Release_Time, "HH:mm:ss").format("h:mmA")}
                                            </div>
                                        </div>
                                        <div className="overlay_section_details_date_arrow_container"><i className="fas fa-arrow-right overlay_section_details_date_arrow"></i></div>
                                        <div className="overlay_section_details_date_right">
                                            <div className="booking_main_date_text_active">
                                                {moment(this.props.endUser.current_booking.End_Date).format("MMM DD, YYYY")}
                                            </div>
                                            <div className="booking_main_date_text_active">
                                                {moment(this.props.endUser.current_booking.Return_Time, "HH:mm:ss").format("h:mmA")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="booking_main_item">
                                <div className="booking_main_item_header booking_main_item_active">
                                    <span className="booking_main_item_header_text mb-8"><Trans>Booking Information</Trans></span>
                                </div>
                                <div className="booking_main_item_subheader booking_main_item_active">
                                    <ProfileCell profile={this.props.endUser.current_booking.profile} booking={this.props.endUser.current_booking} showImage noOverlay noTooltip />
                                </div>
                                <div className="booking_main_item_subheader booking_main_item_active mt-8">
                                    <div>
                                        {
                                            this.props.endUser.current_booking.Book_Type === constants.booking_type.service ?
                                                "Service Booking"
                                                :
                                                this.props.settings.vehicle_usage_types[parseInt(this.props.endUser.current_booking.Usage_Type)]
                                        }
                                    </div>
                                </div>
                                <div>
                                    <div className="mt-8">{this.props.endUser.current_booking.Special_Requests}</div>
                                </div>
                            </div>
                        </div>
                        {
                            (this.props.endUser.current_booking.Released_On === null || this.props.endUser.current_booking.Returned_On === null) && this.props.endUser.current_booking.Book_Status !== constants.booking_status.cancelled && this.props.endUser.current_booking.Book_Status !== constants.booking_status.denied ?
                                <div className="booking_bottom border-top">
                                    <CancelBookingButton legacyApiCancelBooking={this.cancelBooking} booking={this.props.endUser.current_booking} closePullout={this.closePullout} fetchBookings={this.grabBookings} />
                                    <a className="button primary ml-16" onClick={this.editBooking}><Trans>Edit</Trans></a>
                                </div>
                                :
                                null
                        }
                    </div>
                )
            }
        } else {
            return (
                null
            )
        }

    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    endUser: store.endUser,
    data: store.data,
    settings: store.settings
});

export default connect(mapStateToProps)(EUBookingPullout);